import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { cn, devOrProd, isDev } from './utils';

const BrazeForm = ({ children, className, inputPlaceholder, envelope }) => {
  const [email, setEmail] = useState('');
  const [invalidInput, setInvalidInput] = useState('');
  const [postStatus, setPostStatus] = useState(0); // 0 === not posted | 1 === successful post | 2 === failed post
  const [errors, setErrors] = useState([]);
  const [submissionAllowed, setSubmissionAllowed] = useState(true);

  function saveFormBraze() {
    const randomString = () => {
      return Math.random().toString(36).substring(7);
    };

    var sendFormData = new FormData();
    sendFormData.append('formInput', email);
    sendFormData.append('formExternalID', email);

    isDev && console.log('formData:', Object.fromEntries(sendFormData));

    fetch(
      `https://support.footasylum.co.uk/api/braze/seven-signup/${devOrProd}/index-braze.php?v=` +
        randomString(),
      {
        method: 'POST',
        body: sendFormData
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log('in post:', data);
        if (data.message && data.message === 'success') {
          setPostStatus(1);
          setErrors([]);
          setSubmissionAllowed(false);
        } else {
          setSubmissionAllowed(true);
          setPostStatus(2);
          errors.push(
            'There was a problem submitting the form. Please try again.'
          );
          console.log('data', data);
        }
      })
      .catch(function () {
        setPostStatus(2);
        errors.push('There was a problem on our side. Please try again later.');
      })
      .finally(() => console.log('fetch finished'));
  }

  const handleChange = (e) => {
    // reset error message and set email in state
    if (postStatus !== 0) setPostStatus(0);
    e.target.setCustomValidity('');
    setInvalidInput(invalidInput.replace('email', '')); // remove email from invalidInput
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    setSubmissionAllowed(false);
    saveFormBraze();
  };

  return (
    <div className={cn('', className)}>
      {submissionAllowed || postStatus !== 1 ? (
        <>
          {children}
          <ErrorBoundary
            fallback={
              <p>
                There was an error whilst sending the form, please try again.
              </p>
            }
          >
            {errors && (
              <div className="flex flex-col gap-2">
                {errors.map((error, i) => (
                  <p
                    key={i}
                    className="text-balance text-center text-sm font-bold text-destructive"
                  >
                    {error}
                  </p>
                ))}
              </div>
            )}
            {/*isDev && <p className="!p-0 text-sm">Post Status: {postStatus}</p>*/}
            <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-8 pt-6 pb-0 w-full">
              <form
                onSubmit={handleSubmit}
                className="relative flex items-stretch gap-4 m-0 w-full"
              >
                <input
                  required
                  name="emailAddress"
                  type="email"
                  placeholder={inputPlaceholder}
                  value={email}
                  onChange={handleChange}
                  className="w-full py-2 pl-8 pr-24 lg:pr-20 h-24 lg:h-16 rounded-lg text-base border-t-0 border-r-0 border-l-0 border-b border-solid border-[#e0e0e0] placeholder:font-bold placeholder:tracking-wider placeholder:text-[#a0a0a0] placeholder:text-md"
                />
                <button
                  id="submit"
                  type="submit"
                  className={cn(
                    'banner-form-button h-16 w-16 lg:h-12 lg:w-16 absolute right-6 lg:right-3 top-4 lg:top-2 border-b border-solid border-[#e0e0e0] bg-none py-2 px-0.5'
                  )}
                >
                  {envelope}
                </button>
              </form>
            </div>
          </ErrorBoundary>
        </>
      ) : (
        <p className="!m-0 !p-0 text-start !text-base font-normal text-[#3cb371]">
          {postStatus === 1 && <>You have successfully signed up</>}
        </p>
      )}
    </div>
  );
};

export default BrazeForm;
